import { useState } from "react";
import { saveJsonURL } from "../../utils/ConstantsURL";
import { publishJsonURL } from "../../utils/ConstantsURL";

export const useSendJson = () => {
  const [loadingSend, setLoadingSend] = useState(false);
  const [messageSend, setMessageSend] = useState("");

  const saveJson = async (formData) => {
    try {
      setLoadingSend(true);
      setMessageSend("");

      const response = await fetch(
        saveJsonURL(),
        {
          method: "POST",
          body: formData, 
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || "Error al guardar"
        );
      }

      setMessageSend("JSON guardado correctamente");

      return true;
    } catch (error) {
      setMessageSend(
        error.message || "Error al guardar"
      );
      return false;
    } finally {
      setLoadingSend(false);
    }
  };

  const publishJson = async () => {
    try {
      setLoadingSend(true);
      setMessageSend("");

      const response = await fetch(
        publishJsonURL(),
        {
          method: "POST",
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || "Error al publicar"
        );
      }

      setMessageSend("Publicado correctamente 🚀");

      return true;
    } catch (error) {
      setMessageSend(
        error.message || "Error al publicar"
      );
      return false;
    } finally {
      setLoadingSend(false);
    }
  };

  return {
    saveJson,
    publishJson,
    loadingSend,
    messageSend,
  };
};